import React from 'react';
import QRCode from 'qrcode';
import { handleAppStoreClick, handlePlayStoreClick } from '../utils/appStoreLinks';

const QRModal = ({ isOpen, onClose }) => {
  const [qrDataUrl, setQrDataUrl] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (isOpen) {
      generateQRCode();
    }
  }, [isOpen]);

  const generateQRCode = async () => {
    setLoading(true);
    try {
      // Create a universal app download URL that will redirect to appropriate store
      const appUrl = 'https://thecrappermapper.com/download';
      
      const qrDataUrl = await QRCode.toDataURL(appUrl, {
        width: 256,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M'
      });
      
      setQrDataUrl(qrDataUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '32px',
        textAlign: 'center',
        maxWidth: '320px',
        width: '100%',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666'
          }}
        >
          ×
        </button>

        <h3 style={{
          margin: '0 0 16px 0',
          fontSize: '20px',
          fontWeight: '600',
          color: '#5752e8'
        }}>
          Scan to Download
        </h3>

        <p style={{
          margin: '0 0 24px 0',
          fontSize: '14px',
          color: '#666',
          lineHeight: '1.4'
        }}>
          Scan this QR code with your phone camera to download The Crapper Mapper
        </p>

        {loading ? (
          <div style={{
            width: '256px',
            height: '256px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            margin: '0 auto'
          }}>
            Loading...
          </div>
        ) : (
          <img
            src={qrDataUrl}
            alt="Download The Crapper Mapper"
            style={{
              width: '256px',
              height: '256px',
              border: '1px solid #e0e0e0',
              borderRadius: '8px'
            }}
          />
        )}

        <div style={{
          marginTop: '24px',
          display: 'flex',
          gap: '12px',
          justifyContent: 'center'
        }}>
          <a
            href="https://apps.apple.com/us/app/the-crapper-mapper/id6756213834"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleAppStoreClick()}
            style={{
              display: 'inline-block',
              padding: '8px 16px',
              backgroundColor: '#000',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: '500'
            }}
          >
            App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.thecrappermapper.crappermapper"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handlePlayStoreClick()}
            style={{
              display: 'inline-block',
              padding: '8px 16px',
              backgroundColor: '#000',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: '500'
            }}
          >
            Google Play
          </a>
        </div>
      </div>
    </div>
  );
};

export default QRModal;
